import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AccountState {
  user: {
    id: string;
    name: string;
    email: string;
    country: string;
    company: string;
    token?: string;
    username?: string;
    password?: string;
  } | null;
  isAuthenticated: boolean;
  loginTimestamp: number | null;
  setUser: (user: {
    id: string;
    name: string;
    email: string;
    country: string;
    company: string;
    token?: string;
    username?: string;
    password?: string;
  }) => void;
  clearUser: () => void;
}

export const useAccountStore = create<AccountState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      loginTimestamp: null,
      setUser: (user) =>
        set((state) => ({
          ...state,
          user,
          isAuthenticated: true,
          loginTimestamp: Date.now(),
        })),
      clearUser: () =>
        set((state) => ({
          ...state,
          user: null,
          isAuthenticated: false,
          loginTimestamp: null,
        })),
    }),
    {
      name: "account-storage", // key in localStorage
    }
  )
);
